import { $axios, apiList } from '@/api'

export default {
    actions: {
        getUserGradesTable(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.grades.getUserGradesTable.method,
                    params: {
                        wsfunction: apiList.grades.getUserGradesTable.moodle_method,
                        courseid: payload,
                        // userid: 2
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getUserGradesReport() {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.grades.getCourseGrades.method,
                    params: {
                        wsfunction: apiList.grades.getCourseGrades.moodle_method,
                        // userid: 2
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getCourseGradeItems(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.grades.getCourseItemsGrades.method,
                    params: {
                        wsfunction: apiList.grades.getCourseItemsGrades.moodle_method,
                        courseid: payload.course,
                        userid: payload.user
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
